var _linearGradient, _path, _rect, _line, _line2, _line3, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff7e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f33f5e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M7,62c-1.656,0-3-1.344-3-3s1.344-3,3-3s3,1.344,3,3h2V5c0-2.762-2.238-5-5-5S2,2.238,2,5v49v5     c0,2.762,2.238,5,5,5h34v-2H7z",
    className: "colorF4432C svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 54,
    x: 12,
    y: 5,
    fill: "url(#gradient)",
    className: "colorFFD129 svgShape"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 7,
    y1: 24,
    y2: 26,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 7,
    y1: 28,
    y2: 30,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    x2: 7,
    y1: 32,
    y2: 34,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 32,
    y1: 11,
    y2: 11,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 47,
    y1: 33,
    y2: 33,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 47,
    y1: 37,
    y2: 37,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    x2: 47,
    y1: 41,
    y2: 41,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    x2: 47,
    y1: 45,
    y2: 45,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    x2: 47,
    y1: 49,
    y2: 49,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 38,
    y1: 53,
    y2: 53,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    x2: 47,
    y1: 53,
    y2: 53,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 16,
    x: 17,
    y: 14,
    fill: "#f16900",
    className: "colorF4432C svgShape"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 20,
    y1: 28,
    y2: 25,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    x2: 24,
    y1: 28,
    y2: 22,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    x2: 28,
    y1: 28,
    y2: 24,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    x2: 32,
    y1: 28,
    y2: 18,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    x2: 36,
    y1: 28,
    y2: 21,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    x2: 40,
    y1: 28,
    y2: 16,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    x2: 44,
    y1: 28,
    y2: 20,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFF svgStroke"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 17,
    y: 40,
    fill: "#f16900",
    className: "colorF4432C svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 20,
    y: 43,
    fill: "#000",
    className: "colorFFF svgShape"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 59,
    x2: 59,
    y1: 5,
    y2: 8,
    fill: "none",
    stroke: "#f4832c",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeF4432C svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8629",
    d: "M58,64c-0.256,0-0.512-0.098-0.707-0.293S57,63.256,57,63v-2h4v2c0,0.256-0.098,0.512-0.293,0.707    S60.256,64,60,64H58z",
    className: "colorFFD129 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 46,
    x: 56,
    y: 15,
    fill: "url(#gradient)",
    className: "colorF4432C svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ff8629",
    points: "60 8 62 15 56 15 58 8",
    className: "colorFFD129 svgShape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    x2: 62,
    y1: 56,
    y2: 56,
    fill: "none",
    stroke: "#ff8629",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFD129 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    x2: 62,
    y1: 18,
    y2: 18,
    fill: "none",
    stroke: "#ff8629",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFD129 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    x2: 62,
    y1: 22,
    y2: 22,
    fill: "none",
    stroke: "#ff8629",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStrokeFFD129 svgStroke"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFam);
export default __webpack_public_path__ + "static/media/fam.5f90f522f9c8babce125937e1d0cb0b9.svg";
export { ForwardRef as ReactComponent };